export default {
  sourcingOrderTitle: {
    id: 'payment_result_success_sourcing_order_title',
    defaultMessage: 'And for your buyback - {title}',
  },
}
